import React from "react";
import Pagetitle from "../elements/Pagetitle";
import { useGlobalContext } from "../../context/global";

function About() {
  const { data } = useGlobalContext();
  const {
    _links: { cvLink = "" } = {},
    _about: {
      avatarImage = "",
      name = "",
      skills: { col1 = [], col2 = [] } = {},
      content = "",
    } = {},
  } = data || {};

  return (
    <section id="about">
      <div className="container">
        <Pagetitle title="About Me" />
        <div className="row">
          <div className="col-md-3">
            <div className="text-center text-md-left">
              <img src={avatarImage} alt={name} />
            </div>
            <div className="spacer d-md-none d-lg-none" data-height="30"></div>
          </div>

          <div className="col-md-9 triangle-left-md triangle-top-sm">
            <div className="rounded bg-white shadow-dark padding-30">
              <div className="row">
                <div className="col-md-6">
                  <p>{content}</p>
                  <div className="mt-3">
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={cvLink}
                      className="btn btn-default"
                    >
                      Download CV
                    </a>
                  </div>
                  <div
                    className="spacer d-md-none d-lg-none"
                    data-height="30"
                  ></div>
                </div>
                <div className="col-md-6">
                  <span style={{ fontWeight: "bold" }}>Skills:</span>
                  <div className="row">
                    <div className="col">
                      <ul>
                        {col1?.map((item) => (
                          <li key={item}>{item}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="col">
                      <ul>
                        {col2?.map((item) => (
                          <li key={item}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="spacer" data-height="70"></div>
      </div>
    </section>
  );
}

export default About;
